import { TabPanel, TabPanels, Tabs } from "react-aria-components";

import { Tab2 } from "@/ui2/atoms/Tab";
import { TabList2 } from "@/ui2/atoms/TabList";

import { SuccessExecutivePanel } from "./components/SuccessExecutivePanel";
import { SuccessManagerPanel } from "./components/SuccessManagerPanel";

export function CustomerSuccessTabs() {
  return (
    <Tabs className="tw:flex tw:flex-col tw:gap-4" defaultSelectedKey="customer-success">
      <TabList2 aria-label="Customer success" className="tw:px-6">
        <Tab2 id="customer-success">Customer Success</Tab2>
        <Tab2 id="executives">Executives (CSE)</Tab2>
      </TabList2>

      <TabPanels>
        <TabPanel id="customer-success">
          <SuccessManagerPanel />
        </TabPanel>

        <TabPanel id="executives">
          <SuccessExecutivePanel />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
